import { X } from 'lucide-react';

/** 355: names the filter a dashboard link applied, with a way out. */
export function UrlFilterChip({ label, onClear }: { label: string; onClear: () => void }) {
  return (
    <div
      data-testid="url-filter-chip"
      className="mb-4 inline-flex items-center gap-2 rounded-full border border-hairline-strong bg-brand-blue-soft py-1 pr-1 pl-3 text-sm text-primary-deep"
    >
      <span>Showing: {label}</span>
      <button
        type="button"
        aria-label={`Clear filter: ${label}`}
        onClick={onClear}
        className="rounded-full p-1 hover:bg-canvas"
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    </div>
  );
}
